
<div style="width:500px;">
  <div style="width:99%;">
  <span> <button class="btn btn border" (click)="saveCommittee()" [disabled]="!form.dirty">Spara</button>  <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><hr />
 <form [formGroup]="form">

  <!--div class="row">
 <div class="col-md-2">
   <label>
     Id
   </label>
   <input id="id" type="text" class="form-control form-control-sm" formControlName="id"
     readonly>
   </div>
  </div-->

  <div class="row">
   <div class="col-md-10">
     <label>
       Namn
     </label>
     <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
   </div>
  </div>

  <div class="row">
   <div class="col-md-4">
     <label>
       Förkortning
     </label>
     <input id="abbreviation" type="text" class="form-control form-control-sm" formControlName="abbreviation">
   </div>
  </div>

<div class="row">
    <div class="col-md-3">
     <label>
       Sorteringsordning
     </label>
     <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
   </div>
  </div>

   </form>
   </div>
 </div>


